import { useMemo } from 'react';

import { isEqual } from 'lodash';
import useSWR from 'swr';

import { apiClient } from '@src/clients';

interface useGetIndiceById {
  ids: (string | undefined | null)[];
}

export const useGetIndiceById = ({ ids }: useGetIndiceById) => {
  const idLen = useMemo(
    () => ids.filter(d => typeof d === 'string').length,
    [ids]
  );

  const { data, isLoading } = useSWR(
    idLen > 0 ? `indice/${ids.join(',')}` : null,
    () =>
      apiClient.atlasApi.v2.listIndicesV2IndicesGet({
        index_ids: ids.join(',')
      }),
    {
      refreshInterval: 0,
      revalidateOnFocus: false,
      revalidateIfStale: false,
      compare: (a, b) => isEqual(a?.data.indices, b?.data.indices)
    }
  );

  return useMemo(
    () => ({
      indice: data?.data?.indices ?? [],
      isIndiceByIdLoading: isLoading
    }),
    [data, isLoading]
  );
};
